import { render } from "./Footer.vue?vue&type=template&id=27f46840"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layout/Footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27f46840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27f46840', __exports__)) {
    api.reload('27f46840', __exports__)
  }
  
  module.hot.accept("./Footer.vue?vue&type=template&id=27f46840", () => {
    api.rerender('27f46840', render)
  })

}


export default __exports__